import { IconButton, Menu, MenuItem } from "@mui/material";
import { Delete, EditIcon, MoreOptionsIcon } from "components/atoms/Icon";
import useBuildingSidebarState from "recoilStore/CustomPlan/useBuildingSidebarState";
import DangerousModal from "components/molecules/DangerousModal";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";
import { useDeleteCustomCarbonReductionPlan } from "mutations/CustomPlans/useDeleteCustomCarbonReductionPlan";
import { buildDeleteCustomPlanModalOptions } from "pages/BuildingPage/CustomPlan/Header/CustomPlanHeader.utils";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import posthog from "posthog-js";
import styles from "./CustomPlanMenu.module.scss";

interface CustomPlanMenuProps {
    currentCarbonReductionPlanUid: string;
}

function CustomPlanMenu({ currentCarbonReductionPlanUid }: CustomPlanMenuProps) {
    const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

    const handleMoreOptionsClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElement(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    const buildingModelUid = useBuildingModelUid();
    const navigate = useNavigate();

    const { mutate: mutationDeletePlan, isLoading: deleteCustomPlanLoading } = useDeleteCustomCarbonReductionPlan();

    const deleteCustomPlanModalOptions = buildDeleteCustomPlanModalOptions(deleteCustomPlanLoading);
    const { state: sidebarState, setState: setSidebarState } = useBuildingSidebarState();

    const handleDeleteCustomPlan = () => {
        posthog.capture("Delete plan");

        mutationDeletePlan(
            {
                carbonReductionPlanUid: currentCarbonReductionPlanUid,
                buildingModelUid,
            },
            {
                onSuccess: () => {
                    navigate(`/buildings/${buildingModelUid}`);
                    setDeleteModalIsOpen(false);
                },
            }
        );
    };

    return (
        <>
            <div>
                <IconButton onClick={handleMoreOptionsClick}>
                    <MoreOptionsIcon />
                </IconButton>
                <Menu anchorEl={anchorElement} open={Boolean(anchorElement)} onClose={handleClose}>
                    <MenuItem
                        onClick={() => {
                            setSidebarState({
                                ...sidebarState,
                                isCustomPlanSidebarOpen: true,
                            });
                            handleClose();
                        }}
                    >
                        <div className={`${styles.buttonContainer}`}>
                            <EditIcon />
                            Rename
                        </div>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            setDeleteModalIsOpen(true);
                            handleClose();
                        }}
                    >
                        <div className={`${styles.buttonContainer} ${styles.deleteButton}`}>
                            <Delete />
                            Delete Plan
                        </div>
                    </MenuItem>
                </Menu>
            </div>
            <DangerousModal
                open={deleteModalIsOpen}
                onCancel={() => setDeleteModalIsOpen(false)}
                onDelete={handleDeleteCustomPlan}
                options={deleteCustomPlanModalOptions}
                styleType="primary-negative"
                loading={deleteCustomPlanLoading}
            />
        </>
    );
}

export default CustomPlanMenu;
